import { render, staticRenderFns } from "./Supplementary.vue?vue&type=template&id=03f63b49&scoped=true"
import script from "./Supplementary.vue?vue&type=script&lang=js"
export * from "./Supplementary.vue?vue&type=script&lang=js"
import style0 from "./Supplementary.vue?vue&type=style&index=0&id=03f63b49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f63b49",
  null
  
)

export default component.exports